export enum SatisfactionSurveyResolution {
  ANSWERED = 'ANSWERED',
  CONTINUED = 'CONTINUED',
}

export interface SatisfactionSurvey {
  shouldShow: boolean;
  url: string | null;
  message: string | null;
}
